import React, { Component } from "react";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleButton from "../../../modules/commons/SimpleButton";
import ButtonAction from "../../../modules/commons/ButtonAction";
import { mapToObjectDDL } from "../../common/mapper";
import debounce from "lodash.debounce";
import { ACTIVITY_TYPE } from "../../common/Constants";
import FlexView from "react-flexview";
import { defaultTableChange } from "../../../modules/custom/customTable";

const wildcardMatch = (text, pattern) => {
  if (!text || !pattern) return false;

  const escaped = pattern.replace(/[-\/\\^$+?.()|[\]{}]/g, "\\$&");
  const regexPattern = "^" +
    escaped.replace(/%/g, ".*").replace(/_/g, ".") +
    "$";

  return new RegExp(regexPattern, "i").test(text);
};

class PoTable extends Component {
  static lastPageByTab = {};
  constructor(props) {
    super(props);
    this.lastPage = 1;
    const savedPage = PoTable.lastPageByTab[props.tab] || 1;
    this.state = {
      keyword: null,
      searchValue: null,
      pagination: {
          page: savedPage,
          limit: 5,
          totalData: 0,
      },
    };
  }
  tableColumnsTen2 = [
    {
      name: "remainingStockAfter",
      label: "Sisa Stock After Ten. 1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesTarget",
      label: "Target Sales Tent.2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_sales_target"
              name="salesTarget"
              containerclassname="margin-bottom-none"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poTen2"
                )
              }
            />
          );
        },
      },
    },
    {
      name: "salesDay",
      label: "Sales/Day Tent.2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "remainingStock",
      label: "Sisa Stok Tent.2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "stockDays",
      label: "Stock Days Tent.2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "delta",
      label: "Delta",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "potentativeRecommendation",
      label: "PO Tent.2 Recommended",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "potentativeReal",
      label: "PO Tent.2 Real",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_text_qty_po_real"
              name="potentativeReal"
              containerclassname="margin-bottom-none"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poTen2"
                )
              }
            />
          );
        },
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
  ];

  tableColumnsTen1 = [
    {
      name: "remainingStockAfter",
      label: "Sisa Stock After Fix",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesTarget",
      label: "Target Sales Tent.1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_sales_target"
              name="salesTarget"
              containerclassname="margin-bottom-none"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poTen1"
                )
              }
            />
          );
        },
      },
    },
    {
      name: "salesDay",
      label: "Sales/Day Tent.1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "remainingStock",
      label: "Sisa Stok Tent.1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "stockDays",
      label: "Stock Days Tent.1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "delta",
      label: "Delta",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "potentativeRecommendation",
      label: "PO Tent.1 Recommended",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "potentativeReal",
      label: "PO Tent.1 Real",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_text_qty_po_real"
              name="potentativeReal"
              containerclassname="margin-bottom-none"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poTen1"
                )
              }
            />
          );
        },
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
  ];

  tableColumnsPoFix = [
    {
      name: "currentStock",
      label: "Curr. Stock",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "poFixQtyLastMonth",
      label: "Qty PO Fix M-1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "totalSalesLastYear",
      label: "Sales (Last 1 Yr)",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesDayYear",
      label: "Sales/Day Yr",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesMtd",
      label: "Sales MTD",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesDayMtd",
      label: "Sales/Day MTD",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesProjectionMtd",
      label: "Proyeksi Sales MTD",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_text_proyeksi_sales_mtd"
              name="salesProjectionMtd"
              containerclassname="margin-bottom-none width-100px"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poFix"
                )
              }
            />
          );
        },
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "currentStockTwoMonthsLater",
      label: "Curr. Stock M+2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesProjectionTwoMonthsLater",
      label: "Proyeksi Sales M+2",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_text_proyeksi_sales_m"
              name="salesProjectionTwoMonthsLater"
              containerclassname="margin-bottom-none width-100px"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poFix"
                )
              }
            />
          );
        },
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "stockDays",
      label: "Stok Days",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "acuanStock",
      label: "Acuan",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "delta",
      label: "Delta",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "qtyRecommendation",
      label: "Qty PO Rec.",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "qtyPoReal",
      label: "Qty PO Real",
      options: {
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              readOnly={this.props.readOnly}
              id="input_text_qty_po_real"
              name="qtyPoReal"
              containerclassname="margin-bottom-none width-100px"
              value={val}
              box="onlyNumber"
              onChange={({ target }) =>
                this.props.onValueChange(
                  rowIndex,
                  target.name,
                  target.value,
                  "poFix"
                )
              }
            />
          );
        },
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
  ];

  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
        setCellHeaderProps: () => ({
          style: {
            width: "40px",
            position: "sticky",
            left: "0px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            width: "40px",
            position: "sticky",
            left: "0px",
            background: "white",
            zIndex: 2,
          },
        }),
      },
    },
    {
      name: "namaPart",
      label: "Nama Part",
      options: {
        setCellHeaderProps: () => ({
          style: {
            minWidth: "200px",
            position: "sticky",
            left: "50px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            minWidth: "200px",
            position: "sticky",
            left: "50px",
            background: "white",
            zIndex: 2,
          },
        }),
        customBodyRender: (val, { rowIndex, rowData }) => {
          const { partOptions, onFilterDDL } = this.props;
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val?.label;
          }

          return (
            <SimpleDDL
              readOnly={this.props.readOnly}
              id="dropdown_nama_part"
              name="namaPart"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              options={partOptions?.map((item) => ({
                ...item,
                label: item.partName,
                value: item.kodePart,
              }))}
              onMenuOpen={()=> onFilterDDL()}
              box="search"
              containerclassname="margin-bottom-none width-200px"
              value={val}
              onChange={(value, { name }) => {
                this.props.onChangePart(rowIndex, name, value);
                this.props.onChangePart(
                  rowIndex,
                  "kodePart",
                  mapToObjectDDL(value?.kodePart, value?.kodePart)
                );
                this.props.onGetTempData(value?.kodePart, rowIndex);
              }}
            />
          );
        },
      },
    },
    {
      name: "kodePart",
      label: "Kode Part",
      options: {
        setCellHeaderProps: () => ({
          style: {
            minWidth: "200px",
            position: "sticky",
            left: "180px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            minWidth: "200px",
            position: "sticky",
            left: "180px",
            background: "white",
            zIndex: 2,
          },
        }),
        customBodyRender: (val, { rowIndex, rowData }) => {
          const { partOptions, onFilterDDL } = this.props;
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val?.value;
          }
          return (
            <SimpleDDL
              readOnly={this.props.readOnly}
              id="dropdown_kode_part"
              name="kodePart"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              box="search"
              containerclassname="margin-bottom-none width-200px"
              value={val}
              onMenuOpen={()=> onFilterDDL()}
              options={partOptions?.map((item) => ({
                ...item,
                label: item.kodePart,
                value: item.kodePart,
              }))}
              onChange={(value, { name }) => {
                this.props.onChangePart(rowIndex, name, value);
                this.props.onChangePart(
                  rowIndex,
                  "namaPart",
                  mapToObjectDDL(value?.partName, value?.partName)
                );
                this.props.onGetTempData(value?.kodePart, rowIndex);
              }}
            />
          );
        },
      },
    },
    ...(this.props.tab === "poFix"
      ? this.tableColumnsPoFix
      : this.props.tab === "poTen1"
      ? this.tableColumnsTen1
      : this.tableColumnsTen2),
    {
      name: "isSaved",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          const { onDeleteRow, activityType, isEdit } = this.props;
          const isReadonly =
            activityType === ACTIVITY_TYPE.VIEW ||
            activityType === ACTIVITY_TYPE.DELETE;
          return (
            <FlexView style={{ gap: "15px" }}>
              {val ? (
                <ButtonAction
                  id="btn_edit"
                  disabled={isReadonly}
                  iconName="fa-pencil-alt"
                  onClick={() =>
                    this.props.onChangePart(rowIndex, "isSaved", false)
                  }
                />
              ) : (
                <ButtonAction
                  id="btn_save"
                  disabled={isReadonly}
                  iconName="fa-save"
                  onClick={() => this.props.onSaveRow(rowIndex)}
                />
              )}
              <ButtonAction
                id="btn_delete"
                disabled={isReadonly || isEdit}
                iconName="fa-trash"
                onClick={() => onDeleteRow(rowIndex)}
              />
            </FlexView>
          );
        },
      },
    },
  ];

  // getDataTable = () => {
  //   const { searchValue } = this.state;
  //   const { dataTable } = this.props;
  //   console.log(searchValue);
  //   console.log(dataTable);
    
  //   return !searchValue
  //     ? dataTable
  //     : dataTable?.filter((item) =>
  //         item.namaPart?.value
  //           ?.toLowerCase()
  //           ?.includes(searchValue?.toLowerCase())
  //       );
  // };

  componentDidUpdate(prevProps) {
    if (prevProps.dataTable.length !== this.props.dataTable.length) {
      this.setState((prev) => ({
        pagination: {
          ...prev.pagination,
          page: PoTable.lastPageByTab[this.props.tab] || 1,
          totalData: this.props.dataTable.length, 
        },
      }));
    }
  }

  getDataTable = () => {
    const { dataTable } = this.props;
    const { searchValue } = this.state;

    let result = dataTable;
    const keyword = searchValue
      ? (searchValue.includes("%") ? searchValue : `%${searchValue}%`)
      : null;

    if (keyword) {
      result = result.filter(row => {
        const nama = row.namaPart?.label || "";
        return wildcardMatch(nama, keyword);
      });
    }

    return result;
  };

  handleChangePage = (tableState) => {
    const page = tableState.page + 1;

    PoTable.lastPageByTab[this.props.tab] = page;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
      },
    }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { onAddData, dataTable, readOnly, activityType, isEdit } = this.props;
    const { keyword, pagination } = this.state;
    
    return (
      <div>
        <FlexView style={{ justifyContent: "space-between" }}>
          <SimpleButton
            text="Tambah"
            disabled={readOnly || isEdit}
            secondary={readOnly || isEdit}
            className="margin-left-none margin-bottom-15px margin-top-15px"
            icon={<i className="fa fa-lg fa-plus margin-right-15px" />}
            onClick={() => onAddData()}
          />
          <FlexView vAlignContent="center" style={{ gap: "15px" }}>
            <SimpleInput
              id="input_nama_part"
              name="keyword"
              placeholder="Input Nama Part ..."
              value={keyword}
              onChange={({ target }) => {
                this.setState({
                  keyword: target.value,
                });
              }}
            />
            <SimpleButton
              id="btn_clear"
              category="action_button"
              onClick={() => {
                this.setState((prev) => ({
                  ...prev,
                  keyword: null,
                }));
              }}
              className="margin margin-bottom-15px"
              icon={<i className="fa fa-lg fa-times" />}
            />
            <SimpleButton
              id="btn_clear"
              category="action_button"
              className="margin margin-bottom-15px"
              onClick={() => {
                this.setState((prev) => ({
                  ...prev,
                  searchValue: prev.keyword,
                }));
              }}
              icon={<i className="fa fa-lg fa-search" />}
            />
          </FlexView>
        </FlexView>
        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          data={this.getDataTable()}
          columns={this.tableColumns}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          footerAdditionalButtons={
            activityType === ACTIVITY_TYPE.CREATE ||
            activityType === ACTIVITY_TYPE.UPDATE ? (
              <SimpleButton
                id="btn_save"
                text="SIMPAN"
                onClick={() => {
                  this.props.onSubmit();
                }}
              />
            ) : activityType === ACTIVITY_TYPE.VIEW ? (
              <SimpleButton
                id="btn_print"
                text="CETAK"
                onClick={() => {
                  const key =
                    this.props.tab === "poFix"
                      ? "PO_FIX"
                      : this.props.tab === "poTen1"
                      ? "PO_TENT 1"
                      : "PO_TENT 2";
                  const fileName =
                    this.props.tab === "poFix"
                      ? "PO_FIX"
                      : this.props.tab === "poTen1"
                      ? "PO_TENT_1"
                      : "PO_TENT_2";
                  const tableName =
                    this.props.tab === "poFix"
                      ? "poFix"
                      : this.props.tab === "poTen1"
                      ? "poTen1"
                      : "poTen2";

                  this.props.onPrint(key, tableName, fileName);
                }}
              />
            ) : (
              <SimpleButton
                id="btn_delete"
                text="HAPUS"
                onClick={() => {
                  this.props.onDelete();
                }}
              />
            )
          }
        />
      </div>
    );
  }
}

export default PoTable;
